import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as Enum from '@/enum';
import { CommonServices } from '@/services/CommonServices';
import { StorageServices } from '@/services/StorageServices';
import router from '@/router';
import store from '@/store';
import { BaseUserClient, BookingClient, BookingVoucherClient, DeferredPaymentClient, ProjectConfigClient } from './Services';

class _LoginServices {
    
    loginCallback(loginData: OM.LoginData){
        store.state.loginData = loginData;
        StorageServices.setLoginData(loginData);
        CommonServices.setAuthToken(loginData.token);

        return new Promise<any>((resolve, reject) => {
            BaseUserClient.getById(loginData.userIdentifier)
            .then(x => {
                store.state.user = x;
                Promise.all([
                    BookingClient.getByCliente(loginData.userIdentifier),
                    BookingVoucherClient.getAvailableBookingVoucher(loginData.userIdentifier),
                    DeferredPaymentClient.getPendingByCustomer(loginData.userIdentifier),
                    ProjectConfigClient.getPaymentConfigVm()
                ])
                .then(xs => {
                    let hasPrenotato = xs[0].findIndex(x => x.stato.value != Enum.AppuntamentoStatus.Respinto && x.stato.value != Enum.AppuntamentoStatus.Annullato) > -1;
                    let availableTickets = xs[1];
                    let acquistiInAttesa = xs[2];
                    store.state.paymentConfig = xs[3];
                    
                    if(router.currentRoute.value.query.redirect){
                        router.push(<string>router.currentRoute.value.query.redirect); 
                    } else {
                        if(store.state.isAdmin() || store.state.isCollaboratore() || store.state.isCliente()){
                            resolve(xs);
                        } else if(!hasPrenotato && availableTickets.length == 0 && acquistiInAttesa.length == 0){
                            resolve(xs);
                        } else {
                            resolve(xs);
                        }
                    }
                })
            })
        })
    }

    logout(){
        let prom = new Promise<void>((resolve, reject) => {
            CommonServices.destroyToken();
            store.state.user = null;
            store.state.loginData = null;
            StorageServices.setLoginData(null);
            StorageServices.setShowSaldo(false);
            
            resolve();
        })
        return prom;
    }

}

export let LoginServices = new _LoginServices();